import Axios from 'axios';
import React, { Component } from 'react'
import { ContractsManager, RatingsManager, UtilizationGraphManager } from '../../../managers';
import { MetricManager } from '../../../managers';
import { utilizationApi } from '../../../services';
import { Heading, Breadcrumb } from '../../common/atoms';
import { handleAppError } from '../../handlers';
import { Tabbar } from '../../common/molecules';
import { SpendingAccount } from '../../common/templates/Utilization';
import OverallSA from './OverallSA';
import { SALES_ROLE } from '../../../constants/overview';
let token = '';

export default class SpendingAccountLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      ratingObj: {},
      utilizationObj: {},
      loading: true,
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = Axios.CancelToken.source();

    var promise1 = utilizationApi.spendingAccountFetchData({ contractId, startDate, endDate, cancelToken: token.token });
    var promise2 = utilizationApi.spendingAccountFetchRatings({ contractId, startDate, endDate, cancelToken: token.token });
    var promise3 = utilizationApi.spendingAccountFetchUtilizationGraph({
      contractId, startDate, endDate,
      cancelToken: token.token,
    });

    Promise.all([promise1, promise2, promise3])
      .then((values) => {
        const resp_arr = (values.map(resp => resp.data))
        var metricObj = new MetricManager(resp_arr[0]);
        var ratingObj = new RatingsManager(resp_arr[1]);
        var utilizationObj = new UtilizationGraphManager ({result : resp_arr[2] , type : 'spending_account'});
        utilizationObj.xAxesLabel = 'Months';
        this.setState({ metricObj , ratingObj, utilizationObj, loading : false})

      })
      .catch((err) => handleAppError(err));
  };
  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'SPENDING_ACCOUNT');
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          startDate: contractObj.formattedData[0].start_date,
          endDate: contractObj.formattedData[0].end_date,
          overallId: contractObj.formattedData[0].contract_id,
          totalCustomers: contractObj.formattedData[0].total_customers,
          total_registered_customers: contractObj.formattedData[0].total_registered_customers
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }

  toggleHelp = () => this.props.toggleHelp('Spending_account');

  content = (selectedContractObj) => {
    // Future it is need to show Overall section 
    // const { loading, overallId } = this.state;
    // if (selectedContractObj.text === 'Overall') {
    //   token && token.cancel();
    //   token = Axios.CancelToken.source();
    //   return <OverallSA contractId={overallId} token={token} />;
    // } 
    // else
    return <SpendingAccount {...this.state} />
  };

  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id, start_date, end_date } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        selectedContractObj: contract,
        metricObj: {},
        ratingObj: {},
        costSavingObj: {},
        utilizationObj: {},
        loading: true,
        show_low_screen: false,
      });
    } else if (contract.text === 'Overall') {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        selectedContractObj: contract,
        loading: false,
        show_low_screen: false,
      });
    }
  };

  navigateToActivityLog = () => {
    var filteredContract = this.state.contractObj.data.filter((contract) => contract.id === this.state.contractId);
    if (filteredContract.length > 0) {
      var { id, start_date, end_date } = filteredContract[0];
      this.props.history.push('/activity-log?point=spending_account', { contract_id: id, start_date, end_date });

    } else {
      var { id, start_date, end_date } = this.state.contractObj.data[0];
      this.props.history.push('/activity-log?point=spending_account', { contract_id: id, start_date, end_date });
    }
  };

  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;
    return (
      <div >
        <div className='flex flex-row justify-between'>
          <div>
            <Breadcrumb
              list={[
                { text: 'Utilization', link: '/spending-account' },
                { text: 'Spending Account', link: '/spending-account' },
              ]}
              classes='mb-1'
            />
              {typeof this.state.selectedContractObj !== 'undefined' && (
                <Heading
                  mainHeading='Spending Account Utilisation of Health checks'
                />
              )}
          </div>    
          <button
            type='submit'
            onClick={this.navigateToActivityLog}
            disabled={ SALES_ROLE === 'sales' }
            className={`block rounded border border-transparent py-2 mb-2 bg-blue-600 text-base font-semibold text-white focus:outline-none px-5 ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          >
            Activity Log
          </button>
        </div>
        <Tabbar
          list={formattedData}
          loading={loading}
          classes='mt-5'
          currentPage={formattedData ? formattedData[0].text : null}
          setContract={this.changeContractId}
        />
        {this.content(this.state.selectedContractObj)}
      </div>
    )
  }
}